import React, { useState, useEffect } from "react";
import systemConfigService from "../../services/systemConfigService";
import styles from "../DomainName/DomainSetter.module.css"; // Reusing styles
import { FaClipboardList, FaCameraRetro } from 'react-icons/fa';

const WorkflowSetter = () => {
    const [config, setConfig] = useState({ registrationFlow: "FULL_DETAIL" });
    const [message, setMessage] = useState("");

    useEffect(() => {
        const fetchConfig = async () => {
            try {
                const data = await systemConfigService.getConfig();
                if (data) setConfig(data);
            } catch (error) {
                setMessage("Failed to fetch workflow settings.");
            }
        };
        fetchConfig();
    }, []);

    const handleUpdate = async (flow) => {
        try {
            const updated = await systemConfigService.updateConfig({ ...config, registrationFlow: flow });
            setConfig(updated);
            setMessage(`Workflow updated to ${flow === "FULL_DETAIL" ? "Full Detail" : "Photo-First"}!`);
            // Auto reload after a delay to ensure MainContent picks up the change if needed
            // setTimeout(() => window.location.reload(), 1500);
        } catch (error) {
            setMessage("Failed to update workflow setting.");
        }
    };

    return (
        <div className={styles.container} style={{ marginTop: '20px' }}>
            <h2 className={styles.heading}>Asset Registration Workflow</h2>
            <p style={{ color: '#64748b', marginBottom: '20px', fontSize: '0.9rem' }}>
                Choose how assets are created when scanning an unassigned QR code.
            </p>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '15px' }}>
                <div 
                    onClick={() => handleUpdate("FULL_DETAIL")}
                    style={{
                        padding: '20px',
                        borderRadius: '12px',
                        border: `2px solid ${config.registrationFlow === "FULL_DETAIL" ? "#3b82f6" : "#e2e8f0"}`,
                        backgroundColor: config.registrationFlow === "FULL_DETAIL" ? "#eff6ff" : "white",
                        cursor: 'pointer',
                        textAlign: 'center',
                        transition: 'all 0.2s ease'
                    }}
                >
                    <FaClipboardList size={32} color={config.registrationFlow === "FULL_DETAIL" ? "#3b82f6" : "#94a3b8"} />
                    <h4 style={{ marginTop: '10px', color: '#1e293b' }}>Full Detail</h4>
                    <p style={{ fontSize: '0.8rem', color: '#64748b', marginTop: '5px' }}>Shows name, description, and tags form.</p>
                </div>

                <div 
                    onClick={() => handleUpdate("PHOTO_FIRST")}
                    style={{
                        padding: '20px',
                        borderRadius: '12px',
                        border: `2px solid ${config.registrationFlow === "PHOTO_FIRST" ? "#3b82f6" : "#e2e8f0"}`,
                        backgroundColor: config.registrationFlow === "PHOTO_FIRST" ? "#eff6ff" : "white",
                        cursor: 'pointer',
                        textAlign: 'center',
                        transition: 'all 0.2s ease'
                    }}
                >
                    <FaCameraRetro size={32} color={config.registrationFlow === "PHOTO_FIRST" ? "#3b82f6" : "#94a3b8"} />
                    <h4 style={{ marginTop: '10px', color: '#1e293b' }}>Photo-First</h4>
                    <p style={{ fontSize: '0.8rem', color: '#64748b', marginTop: '5px' }}>Quickly capture photo and save. Details later.</p>
                </div>
            </div>

            {message && (
                <p className={styles.statusMessage} style={{ 
                    marginTop: '20px', 
                    padding: '10px', 
                    borderRadius: '6px',
                    backgroundColor: message.includes("Failed") ? "#fee2e2" : "#f0fdf4",
                    color: message.includes("Failed") ? "#991b1b" : "#166534"
                }}>
                    {message}
                </p>
            )}
        </div>
    );
};

export default WorkflowSetter;
